import { createAuthClient } from "better-auth/react";
import { z } from "zod";

export const authClient = createAuthClient({
  baseURL: window.location.origin,
});

const browserSessionUserSchema = z.object({
  id: z.string(),
  name: z.string(),
  email: z.string(),
  emailVerified: z.boolean(),
  role: z.enum(["customer", "operator"]).optional(),
});

export type BrowserSessionUser = z.infer<typeof browserSessionUserSchema>;

export function browserSessionUser<Value>(value: Value): BrowserSessionUser | null {
  const parsed = browserSessionUserSchema.safeParse(value);
  return parsed.success ? parsed.data : null;
}
